import React from "react";
import styles from "./Reason.module.css";

import reason_icon from "assets/images/reason_icon.svg";
import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import FailIcon from "component/failIcon/FaiIcon";
import dayjs from "dayjs";

function Reason({ handleClose, application }) {
  return (
    <div className={styles.reason}>
      <div className={styles.icon}>
       <FailIcon/>
      </div>
      <div className={styles.body}>
        <div className={styles.body_top}>
          <img src={reason_icon} alt="" />
          <div className={styles.body_top_text}>
            <Typography variant='h6'>Stanbic Admin rejected this application</Typography>
            <Typography>{dayjs(application.updatedAt).format('D MMMM YYYY')}, {dayjs(application.updatedAt).format('HH:mm:ss')} </Typography>
          </div>
        </div>
        <div className={styles.body_bottom}>
          <Typography>{application?.reason}  </Typography>
        </div>
      </div>
      <div className={styles.btn}>
        <AppButton
          handleAction={() => {
            handleClose();
          }}
          width={"150px"}
          textColor="#FFFFFF"
          btnBg="#0072CE"
          btnText="Close"
        />
      </div>
    </div>
  );
}

export default Reason;